(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7807],{

/***/ 64633:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals/neighborhood",
      function () {
        return __webpack_require__(12541);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);



var ArrowsButtonDownMin = function(param) {
    var _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.gray400 */ .Z.color.gray400 : _color, _size = param.size, size = _size === void 0 ? 16 : _size, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        style: style,
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.3594 5.40002L8.03125 8.8219L4.70312 5.40002L3.75 6.3219L8.03125 10.7281L12.3125 6.3219L11.3594 5.40002Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowsButtonDownMin);


/***/ }),

/***/ 94781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);



var IconLocationPinMono = function(param) {
    var _size = param.size, size = _size === void 0 ? 14 : _size, _fill = param.fill, fill = _fill === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.blue500 */ .Z.color.blue500 : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 14 14",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.00042 7.43283C6.79 7.43687 6.58088 7.39892 6.3853 7.32118C6.18972 7.24345 6.0116 7.1275 5.86136 6.98012C5.71112 6.83274 5.59178 6.65688 5.5103 6.46282C5.42883 6.26877 5.38687 6.06042 5.38687 5.84996C5.38687 5.6395 5.42883 5.43115 5.5103 5.2371C5.59178 5.04304 5.71112 4.86718 5.86136 4.7198C6.0116 4.57241 6.18972 4.45647 6.3853 4.37873C6.58088 4.301 6.79 4.26304 7.00042 4.26708C7.41497 4.27504 7.80984 4.44531 8.1002 4.74129C8.39055 5.03727 8.5532 5.43534 8.5532 5.84996C8.5532 6.26458 8.39055 6.66265 8.1002 6.95863C7.80984 7.25461 7.41497 7.42488 7.00042 7.43283ZM5.76142 0.604918C3.27059 1.16083 1.52409 3.50525 1.62209 6.05558C1.69909 8.05875 2.92817 9.85075 6.58509 13.3665C6.81609 13.5882 7.18592 13.5893 7.41751 13.3671C11.1998 9.73117 12.3852 7.93917 12.3852 5.84967C12.3852 2.47217 9.27426 -0.179082 5.76142 0.605501",
            fill: fill
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconLocationPinMono);


/***/ }),

/***/ 23773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var ValidationCheck = function(param) {
    var _size = param.size, size = _size === void 0 ? 22 : _size, _fill = param.fill, fill = _fill === void 0 ? "#FD7E14" : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.6177 4.08603C17.308 4.10941 17.0333 4.23068 16.8203 4.43801C16.7884 4.46904 16.6991 4.57074 16.6217 4.66402C16.5444 4.7573 14.562 7.15634 12.2165 9.99522C9.87092 12.8341 7.94719 15.1617 7.94154 15.1677C7.93199 15.1779 7.83829 15.0591 6.61926 13.4912C5.89766 12.5631 5.28336 11.7758 5.25414 11.7416C5.04815 11.5005 4.76686 11.3561 4.42726 11.3171C4.03981 11.2727 3.67174 11.4012 3.385 11.681C3.26909 11.7941 3.18925 11.9037 3.1252 12.0379C3.03536 12.226 2.99499 12.428 3.002 12.6544C3.01031 12.9231 3.08506 13.1368 3.24943 13.3616C3.29208 13.42 6.06564 16.9865 6.13862 17.0768C6.20396 17.1577 6.35713 17.3121 6.4381 17.3787C7.01938 17.8566 7.7708 18.0264 8.49981 17.8445C8.94568 17.7333 9.36276 17.4771 9.67163 17.1248C9.72674 17.062 18.6401 6.27711 18.7207 6.17582C18.859 6.00194 18.9475 5.80736 18.9848 5.59522C19.0002 5.50737 19.0033 5.32047 18.9909 5.21907C18.9532 4.91081 18.8316 4.66495 18.612 4.4526C18.337 4.18674 17.988 4.05808 17.6177 4.08603Z",
            fill: fill
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ValidationCheck);


/***/ }),

/***/ 46799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ skeleton; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/opacity.ts + 1 modules
var opacity = __webpack_require__(52172);
;// CONCATENATED MODULE: ./src/components/atom/skeleton/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    background-position-x: -20%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 5px;\n  ",
        "\n  background-size: 200% 100%;\n  background-position-x: 180%;\n  animation: 1.6s ",
        " ease-in-out infinite;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var loading = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var StyledSkeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a4c00a2-0"
})(_templateObject1(), function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? theme/* default.color.gray40 */.Z.color.gray40 : _backgroundColor, _gradientColor = param.gradientColor, gradientColor = _gradientColor === void 0 ? "#ffffff" : _gradientColor;
    return "\n    background-color: ".concat(backgroundColor, ";\n    background: linear-gradient(\n        120deg,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 40%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "50%"), " 50%,\n        ").concat((0,opacity/* withOpacity */.C)(gradientColor, "0%"), " 60%\n      )\n      ").concat(backgroundColor, ";\n  ");
}, loading);

;// CONCATENATED MODULE: ./src/components/atom/skeleton/index.tsx



var Skeleton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkeleton, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var skeleton = (Skeleton);


/***/ }),

/***/ 16718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ spinner; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/atom/spinner/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dashoffset: -124px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  vertical-align: middle;\n  transform-origin: center;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: none;\n  stroke: ",
        ";\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: ",
        " calc(2s * 0.75) ease-in-out infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var Stretch = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var SpinnerContainer = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-87510cb7-0"
})(_templateObject2(), function(param) {
    var _size = param.size, size = _size === void 0 ? 28 : _size;
    return {
        width: "".concat(size, "px"),
        height: "".concat(size, "px")
    };
}, Rotate);
var SpinnerCircle = styled_components_browser_esm/* default.circle.withConfig */.ZP.circle.withConfig({
    componentId: "sc-87510cb7-1"
})(_templateObject3(), function(param) {
    var _color = param.color, color = _color === void 0 ? theme/* default.color.white */.Z.color.white : _color;
    return color;
}, Stretch);

;// CONCATENATED MODULE: ./src/components/atom/spinner/index.tsx
/* Ref. https://github.com/GriffinJohnston/uiball-loaders/blob/main/src/components/Ring.js */ 

var Spinner = function(param) {
    var color = param.color, size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerContainer, {
        viewBox: "25 25 50 50",
        strokeWidth: "5",
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerCircle, {
            cx: "50",
            cy: "50",
            r: "20",
            color: color
        })
    });
};
/* harmony default export */ var spinner = (Spinner);


/***/ }),

/***/ 8366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loader; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/atom/spinner/index.tsx + 1 modules
var spinner = __webpack_require__(16718);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/molecules/loader/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LoaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-59f274fe-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/molecules/loader/index.tsx



var Loader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {
            size: props.size,
            color: props.color
        })
    });
};
/* harmony default export */ var loader = (Loader);


/***/ }),

/***/ 4380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ EPixelEventName; }
/* harmony export */ });
var EPixelEventName;
(function(EPixelEventName) {
    EPixelEventName["PageIn"] = "page_in";
    EPixelEventName["BottomCtaClick"] = "bottom_cta_click";
    EPixelEventName["TopCtaClick"] = "top_cta_click";
    EPixelEventName["SelectPharmacy"] = "select_pharmacy";
})(EPixelEventName || (EPixelEventName = {}));


/***/ }),

/***/ 11304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rw": function() { return /* binding */ useMedicalCategoriesQuery; },
/* harmony export */   "em": function() { return /* binding */ useFaceToFaceTreatmentKeywordsQuery; }
/* harmony export */ });
/* unused harmony exports MedicalCategoriesDocument, FaceToFaceTreatmentKeywordsDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var MedicalCategoriesDocument = "\n    query MedicalCategories($request: MedicalCategoryRequestInput!) {\n  medicalCategories(request: $request) {\n    id\n    name\n    description\n    iconUrl\n    inflowType\n    label\n    departmentGroupId\n    iconType\n    medicalSubCategories {\n      id\n      name\n      searchInflowType\n      nonBenefitCategoryId\n      nonBenefitItemId\n      prescriptionUnit\n      keyword\n    }\n  }\n}\n    ";
var useMedicalCategoriesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "MedicalCategories",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicalCategoriesDocument, "MedicalCategories", variables), options);
};
useMedicalCategoriesQuery.getKey = function(variables) {
    return [
        "MedicalCategories",
        variables
    ];
};
useMedicalCategoriesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicalCategoriesDocument, "MedicalCategories", variables, options);
};
var FaceToFaceTreatmentKeywordsDocument = "\n    query FaceToFaceTreatmentKeywords {\n  faceToFaceTreatmentKeywords {\n    id\n    name\n  }\n}\n    ";
var useFaceToFaceTreatmentKeywordsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "FaceToFaceTreatmentKeywords"
    ] : [
        "FaceToFaceTreatmentKeywords",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FaceToFaceTreatmentKeywordsDocument, "FaceToFaceTreatmentKeywords", variables), options);
};
useFaceToFaceTreatmentKeywordsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "FaceToFaceTreatmentKeywords"
    ] : [
        "FaceToFaceTreatmentKeywords",
        variables
    ];
};
useFaceToFaceTreatmentKeywordsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FaceToFaceTreatmentKeywordsDocument, "FaceToFaceTreatmentKeywords", variables, options);
};


/***/ }),

/***/ 21586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22970);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72271);
/* harmony import */ var _hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11304);






var parseMedicalCategoriesVo = function(data) {
    var getCategoryIconType = function(iconType) {
        switch(iconType){
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .MedicalCategoryIconType.Animation */ .Gjj.Animation:
                return "ANIMATION";
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .MedicalCategoryIconType.PlainImage */ .Gjj.PlainImage:
            default:
                return "PLAIN_IMAGE";
        }
    };
    return data.medicalCategories.map(function(data) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
            iconType: getCategoryIconType(data.iconType)
        });
    });
};
var useMedicalCategories = function(param) {
    var sortType = param.sortType, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var data = (0,_hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery */ .Rw)({
        request: {
            sortType: sortType
        }
    }, {
        select: parseMedicalCategoriesVo,
        enabled: enabled
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMedicalCategories);
useMedicalCategories.prefetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(queryClient, sortType) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(_hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery.getKey */ .Rw.getKey({
                            request: {
                                sortType: sortType
                            }
                        }), _hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery.fetcher */ .Rw.fetcher({
                            request: {
                                sortType: sortType
                            }
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, sortType) {
        return _ref.apply(this, arguments);
    };
}();
useMedicalCategories.fetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(queryClient, sortType) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery(_hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery.getKey */ .Rw.getKey({
                            request: {
                                sortType: sortType
                            }
                        }), _hospitalMain_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useMedicalCategoriesQuery.fetcher */ .Rw.fetcher({
                            request: {
                                sortType: sortType
                            }
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        parseMedicalCategoriesVo(response)
                    ];
            }
        });
    });
    return function(queryClient, sortType) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 75527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23144);
/* harmony import */ var _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38245);




var useSearchKoreaAddressV2 = function(props) {
    var siDoCode = props.siDoCode, siGunGuCode = props.siGunGuCode;
    var ref = (0,_faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useSearchKoreaAddressV2Query */ .Oy)({
        request: {
            siDoCode: siDoCode,
            siGunGuCode: siGunGuCode
        }
    }, {
        select: _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_1__/* .SearchHospitalService.parseKoreaAddressV2 */ .h.parseKoreaAddressV2
    }), data = ref.data, isLoading = ref.isLoading;
    return {
        data: data,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSearchKoreaAddressV2);
var prefetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(queryClient, props) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(_faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useSearchKoreaAddressV2Query.getKey */ .Oy.getKey({
                            request: {
                                siDoCode: props.siDoCode,
                                siGunGuCode: props.siGunGuCode
                            }
                        }), _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useSearchKoreaAddressV2Query.fetcher */ .Oy.fetcher({
                            request: {
                                siDoCode: props.siDoCode,
                                siGunGuCode: props.siGunGuCode
                            }
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function prefetchQuery(queryClient, props) {
        return _ref.apply(this, arguments);
    };
}();
useSearchKoreaAddressV2.prefetchQuery = prefetchQuery;
var fetcher = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(props) {
        var response, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useSearchKoreaAddressV2Query.fetcher */ .Oy.fetcher({
                            request: {
                                siDoCode: props.siDoCode,
                                siGunGuCode: props.siGunGuCode
                            }
                        })()
                    ];
                case 1:
                    response = _state.sent();
                    data = _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_1__/* .SearchHospitalService.parseKoreaAddressV2 */ .h.parseKoreaAddressV2(response);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetcher(props) {
        return _ref.apply(this, arguments);
    };
}();
useSearchKoreaAddressV2.fetcher = fetcher;


/***/ }),

/***/ 12541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ neighborhood; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/Divider.tsx
var Divider = __webpack_require__(47064);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/components/atom/icon/Chevron.tsx
var Chevron = __webpack_require__(44852);
// EXTERNAL MODULE: ./src/components/atom/icon/hospitals/NonF2fDiagnosisBannerIcon.tsx
var NonF2fDiagnosisBannerIcon = __webpack_require__(55394);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/atom/icon/search/HelpQuestion.tsx
var HelpQuestion = __webpack_require__(74976);
;// CONCATENATED MODULE: ./src/components/templates/hospital/neighborhood/components/EmptyHospital.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  padding-top: 40px;\n  padding-bottom: 80px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin: 16px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var EmptyHospital = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyResultWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpQuestion/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResultTitle, {
                    children: "찾으시는 병원이 없어요"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyResultOffer, {
                    children: [
                        "필터를 확인하고, 위치를 변경해서",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "다시 검색해주세요."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_EmptyHospital = (EmptyHospital);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d939a5db-0"
})(_templateObject());
var EmptyResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d939a5db-1"
})(_templateObject1());
var EmptyResultTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-d939a5db-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var EmptyResultOffer = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d939a5db-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});

;// CONCATENATED MODULE: ./src/components/templates/hospital/neighborhood/components/EmptyNeighborhoodSearchResult.tsx

function EmptyNeighborhoodSearchResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  padding-top: 40px;\n  padding-bottom: 80px;\n"
    ]);
    EmptyNeighborhoodSearchResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmptyNeighborhoodSearchResult_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    EmptyNeighborhoodSearchResult_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmptyNeighborhoodSearchResult_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    EmptyNeighborhoodSearchResult_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmptyNeighborhoodSearchResult_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  white-space: pre-line;\n"
    ]);
    EmptyNeighborhoodSearchResult_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var EmptyNeighborhoodSearchResult = function(param) {
    var title = param.title, description = param.description, noticeIcon = param.noticeIcon, button = param.button;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNeighborhoodSearchResult_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyNeighborhoodSearchResult_EmptyResultWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNeighborhoodSearchResult_EmptyResultTitle, {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyNeighborhoodSearchResult_EmptyResultOffer, {
                    children: description
                }),
                noticeIcon,
                button
            ]
        })
    });
};
/* harmony default export */ var components_EmptyNeighborhoodSearchResult = (EmptyNeighborhoodSearchResult);
var EmptyNeighborhoodSearchResult_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6fd38a-0"
})(EmptyNeighborhoodSearchResult_templateObject());
var EmptyNeighborhoodSearchResult_EmptyResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6fd38a-1"
})(EmptyNeighborhoodSearchResult_templateObject1());
var EmptyNeighborhoodSearchResult_EmptyResultTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-a6fd38a-2"
})(EmptyNeighborhoodSearchResult_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI18SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var EmptyNeighborhoodSearchResult_EmptyResultOffer = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a6fd38a-3"
})(EmptyNeighborhoodSearchResult_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});

// EXTERNAL MODULE: ./src/components/atom/icon/FavoriteStar.tsx
var FavoriteStar = __webpack_require__(34766);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/templates/hospital/neighborhood/components/NeighborhoodSearchDoctorItem.tsx

function NeighborhoodSearchDoctorItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 8px 0;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    NeighborhoodSearchDoctorItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NeighborhoodSearchDoctorItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  gap: 16px;\n  padding: 0 16px 0 22px;\n"
    ]);
    NeighborhoodSearchDoctorItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NeighborhoodSearchDoctorItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    NeighborhoodSearchDoctorItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NeighborhoodSearchDoctorItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 24px;\n  gap: 4px;\n"
    ]);
    NeighborhoodSearchDoctorItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n  margin-top: 8px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 128px;\n  height: 21.333px;\n  background: linear-gradient(0deg, #fff 0%, rgba(255, 255, 255, 0) 100%);\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 128px;\n  height: 128px;\n  background-size: cover;\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-content: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin-left: 4px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin-left: 1px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 12px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  padding: 1px 4px;\n  border-radius: 2px;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}





var NeighborhoodSearchDoctorItem = function(param) {
    var doctorName = param.doctorName, hospitalName = param.hospitalName, doctorProfileImageUrl = param.doctorProfileImageUrl, reviewRating = param.reviewRating, reviewTotalCount = param.reviewTotalCount, videoCallAvailable = param.videoCallAvailable, professionalDepartmentName = param.professionalDepartmentName, isLastItem = param.isLastItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NeighborhoodSearchDoctorItem_Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorInfoWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Names, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorName, {
                                            children: doctorName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalName, {
                                            children: hospitalName
                                        })
                                    ]
                                }),
                                reviewTotalCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Ratings, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteStar/* default */.Z, {
                                            size: 14,
                                            fullColor: theme/* default.color.yellow500 */.Z.color.yellow500
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Score, {
                                            children: reviewRating
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewCount, {
                                            children: [
                                                "(",
                                                reviewTotalCount,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                (videoCallAvailable || !!professionalDepartmentName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badges, {
                                    children: [
                                        !!professionalDepartmentName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfessionalDepartmentBadge, {
                                            children: [
                                                professionalDepartmentName,
                                                "전문의"
                                            ]
                                        }),
                                        videoCallAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCallBadge, {
                                            children: "영상진료"
                                        })
                                    ]
                                })
                            ]
                        }),
                        doctorProfileImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorImage, {
                                    backgroundImage: doctorProfileImageUrl
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlur, {})
                            ]
                        })
                    ]
                })
            }),
            !isLastItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerDivider, {
                    height: "1px",
                    color: theme/* default.color.gray40 */.Z.color.gray40
                })
            })
        ]
    });
};
/* harmony default export */ var components_NeighborhoodSearchDoctorItem = (NeighborhoodSearchDoctorItem);
var NeighborhoodSearchDoctorItem_Wrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-1dcb699c-0"
})(NeighborhoodSearchDoctorItem_templateObject());
var TopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcb699c-1"
})(NeighborhoodSearchDoctorItem_templateObject1());
var DoctorInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcb699c-2"
})(NeighborhoodSearchDoctorItem_templateObject2());
var Names = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcb699c-3"
})(NeighborhoodSearchDoctorItem_templateObject3());
var DoctorName = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-1dcb699c-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), theme.typography.UI16SB, theme.color.gray600);
});
var HospitalName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1dcb699c-5"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), theme.typography.UI13M, theme.color.gray300);
});
var Ratings = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcb699c-6"
})(_templateObject8());
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcb699c-7"
})(_templateObject9());
var ImageBlur = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcb699c-8"
})(_templateObject10());
var DoctorImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcb699c-9"
})(_templateObject11(), function(param) {
    var backgroundImage = param.backgroundImage;
    return backgroundImage && "background-image: url(".concat(backgroundImage, ");");
});
var InnerDivider = (0,styled_components_browser_esm/* default */.ZP)(Divider/* default */.Z).withConfig({
    componentId: "sc-1dcb699c-10"
})(_templateObject12());
var DividerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcb699c-11"
})(_templateObject13());
var Score = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1dcb699c-12"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, "\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var ReviewCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1dcb699c-13"
})(_templateObject15(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, "\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var Badges = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcb699c-14"
})(_templateObject16());
var ProfessionalDepartmentBadge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1dcb699c-15"
})(_templateObject18(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject17(), theme.typography.UI12M, theme.color.blue600, theme.color.blue100);
});
var VideoCallBadge = (0,styled_components_browser_esm/* default */.ZP)(ProfessionalDepartmentBadge).withConfig({
    componentId: "sc-1dcb699c-16"
})(_templateObject20(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject19(), theme.color.gray300, theme.color.gray30);
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/lodash/throttle.js
var throttle = __webpack_require__(12436);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./src/components/atom/icon/IconLocationPinMono.tsx
var IconLocationPinMono = __webpack_require__(94781);
// EXTERNAL MODULE: ./src/components/atom/icon/Phone.tsx
var Phone = __webpack_require__(75528);
// EXTERNAL MODULE: ./src/components/atom/icon/f2f/RightArrowCircle.tsx
var RightArrowCircle = __webpack_require__(64761);
// EXTERNAL MODULE: ./src/components/atom/icon/f2f/SmallRightArrowCircle.tsx
var SmallRightArrowCircle = __webpack_require__(64903);
// EXTERNAL MODULE: ./src/components/atom/images/DoctornowImage.tsx
var DoctornowImage = __webpack_require__(87522);
// EXTERNAL MODULE: ./src/components/hospital/hospital-list-item/DiagnosisStatus.tsx
var DiagnosisStatus = __webpack_require__(88294);
// EXTERNAL MODULE: ./src/types/hospital.ts
var types_hospital = __webpack_require__(24396);
;// CONCATENATED MODULE: ./src/components/templates/hospital/neighborhood/components/NeighborhoodSearchHospitalItem.tsx



function NeighborhoodSearchHospitalItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: 56px;\n  max-height: 56px;\n  border-radius: 8px;\n\n  width: 100%;\n  height: 100%;\n  margin-left: 20px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 0 24px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: hidden;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  & > h2 {\n    ",
        "\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    word-break: break-all;\n  }\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 4px;\n  gap: 4px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin-left: 4px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin-left: 1px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NeighborhoodSearchHospitalItem_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  word-break: break-all;\n  margin-left: 4px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-top: 12px;\n  padding-left: 24px;\n  padding-right: 24px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1px 4px;\n  border-radius: 4px;\n  height: 20px;\n  margin-right: 6px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 6px;\n  ",
        "\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  height: 13px;\n  background-color: ",
        ";\n  margin-left: 8px;\n  margin-right: 8px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    NeighborhoodSearchHospitalItem_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function NeighborhoodSearchHospitalItem_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 21px;\n  display: flex;\n  align-items: center;\n  overflow-x: scroll;\n  white-space: nowrap;\n  padding-left: 24px;\n  padding-right: 24px;\n"
    ]);
    NeighborhoodSearchHospitalItem_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: ",
        ";\n        min-width: ",
        ";\n      "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: ",
        ";\n      min-width: ",
        ";\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  height: 80px;\n\n  margin-right: ",
        "px;\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 12px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 2px;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  margin-right: 2px;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: none;\n      "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: ",
        ";\n    "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  position: absolute;\n  right: 0;\n  bottom: 20px;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  ",
        ";\n  color: ",
        ";\n  margin-top: 2px;\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 48px);\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-content: center;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}














var BadgeItem = function BadgeItem(type, label) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, BadgeItem);
    this.type = type;
    this.label = label;
};
var BadgeType;
(function(BadgeType) {
    BadgeType["Normal"] = "Normal";
    BadgeType["NonF2fDoctor"] = "NonF2fDoctor";
})(BadgeType || (BadgeType = {}));
var NeighborhoodSearchHospitalItem = function(param) {
    var imageUrl = param.imageUrl, status = param.status, name = param.name, rating = param.rating, address = param.address, badges = param.badges, reviewTotalCount = param.reviewTotalCount, representativeDepartmentName = param.representativeDepartmentName, operationDisplay = param.operationDisplay, adBanners = param.adBanners, hospitalPid = param.hospitalPid, onClickAdBanner = param.onClickAdBanner, hasNonF2fDoctors = param.hasNonF2fDoctors, isLastItem = param.isLastItem;
    var visibleBadgeList = (0,react.useMemo)(function() {
        if (hasNonF2fDoctors) {
            return [
                new BadgeItem(BadgeType.NonF2fDoctor, "비대면진료"), 
            ].concat((0,_to_consumable_array/* default */.Z)(badges.slice(0, 2).map(function(badge) {
                return new BadgeItem(BadgeType.Normal, badge);
            })));
        }
        return badges.slice(0, 3).map(function(badge) {
            return new BadgeItem(BadgeType.Normal, badge);
        });
    }, [
        badges,
        hasNonF2fDoctors
    ]);
    var hasMoreBadge = badges.length > visibleBadgeList.length;
    var moreBadgeLength = badges.length - visibleBadgeList.length;
    var ref = (0,react.useState)(false), moreButtonVisible = ref[0], setMoreButtonVisible = ref[1];
    var adBannerScrollRef = (0,react.useRef)(null);
    var checkIsScrollEnd = function(scrollWidth, offsetWidth, scrollLeft) {
        var contentWidth = scrollWidth - offsetWidth;
        var isEnd = contentWidth - scrollLeft <= 10;
        return isEnd;
    };
    var onAdBannerScrollEnd = throttle_default()(function(event) {
        var _target = event.target, scrollWidth = _target.scrollWidth, offsetWidth = _target.offsetWidth, scrollLeft = _target.scrollLeft;
        var isEnd = checkIsScrollEnd(scrollWidth, offsetWidth, scrollLeft);
        setMoreButtonVisible(isEnd ? false : true);
    });
    var onAdBannerMouseEnter = throttle_default()(function() {
        var adBannerScroll = adBannerScrollRef === null || adBannerScrollRef === void 0 ? void 0 : adBannerScrollRef.current;
        if (!adBannerScroll) return;
        var scrollWidth = adBannerScroll.scrollWidth, offsetWidth = adBannerScroll.offsetWidth, scrollLeft = adBannerScroll.scrollLeft;
        var isEnd = checkIsScrollEnd(scrollWidth, offsetWidth, scrollLeft);
        if (!isEnd) {
            setMoreButtonVisible(true);
        }
    });
    (0,react.useEffect)(function() {
        var ref;
        adBannerScrollRef === null || adBannerScrollRef === void 0 ? void 0 : (ref = adBannerScrollRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", onAdBannerScrollEnd);
        return function() {
            var ref;
            adBannerScrollRef === null || adBannerScrollRef === void 0 ? void 0 : (ref = adBannerScrollRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", onAdBannerScrollEnd);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NeighborhoodSearchHospitalItem_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NeighborhoodSearchHospitalItem_TopWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HospitalWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NameWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: name
                                        })
                                    }),
                                    representativeDepartmentName && /*#__PURE__*/ (0,jsx_runtime.jsx)(RepresentativeDepartment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepartmentName, {
                                            children: representativeDepartmentName
                                        })
                                    }),
                                    status !== types_hospital/* DiagnosisState.Unknown */.J0.Unknown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiagnosisTimeWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosisStatus/* default */.Z, {
                                                type: status
                                            }),
                                            !!operationDisplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stick, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OperationDisplayTime, {
                                                        children: operationDisplay
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconInfoWrapper, {
                                        children: [
                                            reviewTotalCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteStar/* default */.Z, {
                                                        size: 14,
                                                        fullColor: theme/* default.color.yellow500 */.Z.color.yellow500
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NeighborhoodSearchHospitalItem_Score, {
                                                        children: rating
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NeighborhoodSearchHospitalItem_ReviewCount, {
                                                        children: [
                                                            "(",
                                                            reviewTotalCount,
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DistanceWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLocationPinMono/* default */.Z, {
                                                        fill: theme/* default.color.gray300 */.Z.color.gray300
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                                                        children: address
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(NeighborhoodSearchHospitalItem_ImageWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctornowImage/* default */.Z, {
                                    objectFit: "cover",
                                    className: "rounded-[8px]",
                                    src: imageUrl,
                                    width: 56,
                                    height: 56,
                                    alt: name,
                                    loading: "lazy"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeWrapper, {
                        hasItem: badges.length > 0,
                        children: [
                            visibleBadgeList.map(function(badge, i) {
                                switch(badge.type){
                                    case BadgeType.Normal:
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            children: badge.label
                                        }, "badge-".concat(name, "-").concat(badge, "-").concat(i));
                                    case BadgeType.NonF2fDoctor:
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonF2fBadge, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, {}),
                                                badge.label
                                            ]
                                        }, "badge-".concat(name, "-").concat(badge, "-").concat(i));
                                }
                            }),
                            hasMoreBadge && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                                children: [
                                    "+",
                                    moreBadgeLength
                                ]
                            }, "badge-".concat(name, "-+"))
                        ]
                    }),
                    !!(adBanners === null || adBanners === void 0 ? void 0 : adBanners.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdBanners, {
                        ref: adBannerScrollRef,
                        onMouseEnter: onAdBannerMouseEnter,
                        onMouseLeave: function() {
                            setMoreButtonVisible(false);
                        },
                        children: [
                            adBanners.map(function(item, index) {
                                if (index > 2) return null;
                                var isSingle = adBanners.length === 1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdBanner, {
                                    isSingle: isSingle,
                                    onClick: function() {
                                        return onClickAdBanner === null || onClickAdBanner === void 0 ? void 0 : onClickAdBanner(item.url, hospitalPid);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctornowImage/* default */.Z, {
                                            src: item.thumbnailImageUrl,
                                            width: 56,
                                            height: 56,
                                            alt: item.title,
                                            loading: "lazy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdContent, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdContentTitle, {
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceWrapper, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountPercent, {
                                                            children: item.displayDiscount
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                                            children: item.displayPrice
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, item.id);
                            }),
                            adBanners.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallRightArrowCircle/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreText, {
                                        children: "더 보기"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoveredMoreIcon, {
                                onClick: function(e) {
                                    var ref, ref1;
                                    e.preventDefault();
                                    var _width;
                                    (ref = adBannerScrollRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
                                        left: adBannerScrollRef.current.offsetLeft + ((_width = (ref1 = adBannerScrollRef.current.firstElementChild) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect().width) !== null && _width !== void 0 ? _width : 0) + 12,
                                        behavior: "smooth"
                                    });
                                },
                                isHovered: moreButtonVisible,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowCircle/* default */.Z, {})
                            })
                        ]
                    })
                ]
            }),
            !isLastItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(NeighborhoodSearchHospitalItem_DividerWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NeighborhoodSearchHospitalItem_InnerDivider, {
                    height: "1px",
                    color: theme/* default.color.gray40 */.Z.color.gray40
                })
            })
        ]
    });
};
/* harmony default export */ var components_NeighborhoodSearchHospitalItem = (NeighborhoodSearchHospitalItem);
var NeighborhoodSearchHospitalItem_Wrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-fc0b3c8d-0"
})(NeighborhoodSearchHospitalItem_templateObject());
var NeighborhoodSearchHospitalItem_ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-1"
})(NeighborhoodSearchHospitalItem_templateObject1());
var NeighborhoodSearchHospitalItem_TopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-2"
})(NeighborhoodSearchHospitalItem_templateObject2());
var HospitalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-3"
})(NeighborhoodSearchHospitalItem_templateObject3());
var NameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-4"
})(NeighborhoodSearchHospitalItem_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n          ".concat(theme.typography.UI17SB, "\n          color: ").concat(theme.color.gray600, ";\n      ");
});
var IconInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-5"
})(NeighborhoodSearchHospitalItem_templateObject5());
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-6"
})(NeighborhoodSearchHospitalItem_templateObject6());
var NeighborhoodSearchHospitalItem_Score = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-fc0b3c8d-7"
})(NeighborhoodSearchHospitalItem_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, "\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var NeighborhoodSearchHospitalItem_ReviewCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-fc0b3c8d-8"
})(NeighborhoodSearchHospitalItem_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, "\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var DistanceWrapper = (0,styled_components_browser_esm/* default */.ZP)(InfoWrapper).withConfig({
    componentId: "sc-fc0b3c8d-9"
})(NeighborhoodSearchHospitalItem_templateObject9());
var Address = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-fc0b3c8d-10"
})(NeighborhoodSearchHospitalItem_templateObject10(), function(param) {
    var theme = param.theme;
    return "\n        ".concat(theme.typography.UI13M, "\n        color: ").concat(theme.color.gray300, ";\n    ");
});
var BadgeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-11"
})(NeighborhoodSearchHospitalItem_templateObject11(), function(param) {
    var hasItem = param.hasItem;
    return hasItem ? "flex" : "none";
});
var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-12"
})(NeighborhoodSearchHospitalItem_templateObject12(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI12M, "\n      color: ").concat(theme.color.gray300, ";\n      background: ").concat(theme.color.gray30, ";\n      ");
});
var NonF2fBadge = (0,styled_components_browser_esm/* default */.ZP)(Badge).withConfig({
    componentId: "sc-fc0b3c8d-13"
})(NeighborhoodSearchHospitalItem_templateObject13(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI12M, "\n      color: ").concat(theme.color.primary600, ";\n      background: ").concat(theme.color.primary100, ";\n      ");
});
var RepresentativeDepartment = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-14"
})(NeighborhoodSearchHospitalItem_templateObject14());
var DepartmentName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-fc0b3c8d-15"
})(NeighborhoodSearchHospitalItem_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.typography.UI12R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var DiagnosisTimeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-16"
})(NeighborhoodSearchHospitalItem_templateObject16());
var Stick = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-17"
})(NeighborhoodSearchHospitalItem_templateObject17(), function(param) {
    var theme = param.theme;
    return theme.color.gray100;
});
var OperationDisplayTime = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-fc0b3c8d-18"
})(NeighborhoodSearchHospitalItem_templateObject19(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NeighborhoodSearchHospitalItem_templateObject18(), theme.typography.UI13R, theme.color.gray400);
});
var AdBanners = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-19"
})(NeighborhoodSearchHospitalItem_templateObject20());
var AdBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-20"
})(_templateObject23(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
}, function(param) {
    var isSingle = param.isSingle;
    return isSingle ? 0 : 12;
}, function(param) {
    var theme = param.theme, isSingle = param.isSingle;
    var client = theme.client;
    if (client.isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject21(), isSingle ? "calc(100% - 24px)" : "calc(100% - 36px)", isSingle ? "calc(100% - 24px)" : "calc(100% - 36px)");
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject22(), isSingle ? "calc(100% - 24px)" : "520px", isSingle ? "calc(100% - 24px)" : "520px");
});
var AdContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-21"
})(_templateObject24());
var AdContentTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-22"
})(_templateObject25(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});
var PriceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-23"
})(_templateObject26());
var DiscountPercent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-24"
})(_templateObject27(), function(param) {
    var theme = param.theme;
    return theme.color.primary800;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16B;
});
var Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-25"
})(_templateObject28(), function(param) {
    var theme = param.theme;
    return theme.color.gray800;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16B;
});
var HoveredMoreIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-26"
})(_templateObject31(), function(param) {
    var theme = param.theme, isHovered = param.isHovered;
    var client = theme.client;
    if (client.isMobile) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject29());
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject30(), isHovered ? "flex" : "none");
});
var MoreWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-27"
})(_templateObject32());
var MoreText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-fc0b3c8d-28"
})(_templateObject33(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});
var NeighborhoodSearchHospitalItem_InnerDivider = (0,styled_components_browser_esm/* default */.ZP)(Divider/* default */.Z).withConfig({
    componentId: "sc-fc0b3c8d-29"
})(_templateObject34());
var NeighborhoodSearchHospitalItem_DividerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc0b3c8d-30"
})(_templateObject35());

// EXTERNAL MODULE: ./src/models/hospital/index.ts
var hospital = __webpack_require__(65808);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
// EXTERNAL MODULE: ./src/views/non-benefit/index.ts + 2 modules
var non_benefit = __webpack_require__(13650);
;// CONCATENATED MODULE: ./src/components/templates/hospital/neighborhood/NeighborhoodHospitalTemplate.tsx


function NeighborhoodHospitalTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NeighborhoodHospitalTemplate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 8px;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    NeighborhoodHospitalTemplate_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    NeighborhoodHospitalTemplate_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 24px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  overflow-x: scroll;\n  white-space: nowrap;\n  margin-bottom: 8px;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    padding: 0 14px;\n    height: 36px;\n    ",
        "\n    color: ",
        ";\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 40px;\n    transition: background-color, color, border 0.2s;\n    & > div > span {\n      color: ",
        ";\n      transition: color 0.2s;\n    }\n  "
    ]);
    NeighborhoodHospitalTemplate_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NeighborhoodHospitalTemplate_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  flex: 1 0 0;\n  border-radius: 8px;\n  background: ",
        ";\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 40px;\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    NeighborhoodHospitalTemplate_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 32px 24px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    white-space: pre-line;\n  "
    ]);
    NeighborhoodHospitalTemplate_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NeighborhoodHospitalTemplate_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  "
    ]);
    NeighborhoodHospitalTemplate_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 48px;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  "
    ]);
    NeighborhoodHospitalTemplate_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    width: 240px;\n  "
    ]);
    NeighborhoodHospitalTemplate_templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function NeighborhoodHospitalTemplate_templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NeighborhoodHospitalTemplate_templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}




















var NeighborhoodHospitalTemplate = function(param) {
    var client = param.client, viewModel = param.viewModel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    visible: !client.isMobile,
                    type: "hospitals",
                    path: common/* ROUTES.HOSPITAL.NEIGHBORHOOD.path */.Z6.HOSPITAL.NEIGHBORHOOD.path + (0,url/* addQueryString */.sC)(viewModel.queries)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NeighborhoodSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HospitalTitleWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, {
                                            children: "".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion), " ").concat(viewModel.queries.keyword, " ").concat(viewModel.neighborhoodHospitalTypes.selectedTypeTitle(viewModel.queries.type), " 병원 (2025)")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDescription, {
                                        children: "닥터나우에서 ".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion), " ").concat(viewModel.queries.keyword, " ").concat(viewModel.neighborhoodHospitalTypes.selectedTypeTitle(viewModel.queries.type), " 병원 정보를 조회한 정보에요.")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HospitalFilterOptionWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterButton, {
                                        onClick: viewModel.openNeighborhoodHospitalTypeBottomSheet,
                                        children: [
                                            "".concat(viewModel.neighborhoodHospitalTypes.selectedTypeTitle(viewModel.queries.type), " 병원"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "chevron_right",
                                                size: 16,
                                                color: theme/* default.color.gray700 */.Z.color.gray700,
                                                rotate: 90,
                                                filled: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterButton, {
                                        onClick: viewModel.openSearchAddressFilterModal,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "my_location",
                                                size: 16,
                                                color: theme/* default.color.gray700 */.Z.color.gray700,
                                                filled: true
                                            }),
                                            "".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterButton, {
                                        onClick: viewModel.openNeighborhoodKeywordBottomSheet,
                                        children: [
                                            "".concat(viewModel.queries.keyword),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "chevron_right",
                                                size: 16,
                                                color: theme/* default.color.gray700 */.Z.color.gray700,
                                                rotate: 90,
                                                filled: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterButton, {
                                        selected: viewModel.queries.filter === hospital/* NeighborhoodHospitalFilter.NonF2fHospital */.nx.NonF2fHospital,
                                        onClick: viewModel.toggleNonF2fHospitalFilter,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "call",
                                                size: 16,
                                                color: theme/* default.color.gray700 */.Z.color.gray700,
                                                filled: true
                                            }),
                                            "비대면 진료"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HospitalListWrapper, {
                                children: [
                                    !viewModel.hospitals.length && !viewModel.isLoadingHospitals && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmptyHospital, {}),
                                    !viewModel.isLoadingHospitals && viewModel.hospitals.length > 0 && viewModel.hospitals.map(function(hospital, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_self",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NeighborhoodSearchHospitalItem, {
                                                            adBanners: hospital.hospitalAdBanners,
                                                            hospitalPid: hospital.hospitalPublicId,
                                                            status: hospital.hospitalOperationStatus,
                                                            name: hospital.hospitalName,
                                                            rating: hospital.reviewScore,
                                                            reviewTotalCount: hospital.reviewTotalCount,
                                                            badges: hospital.hospitalBadges,
                                                            imageUrl: hospital.hospitalRepresentativeImageUrl,
                                                            address: hospital.hospitalAddress,
                                                            representativeDepartmentName: hospital.hospitalRepresentativeDepartmentName,
                                                            operationDisplay: hospital.operationDisplay,
                                                            hasNonF2fDoctors: !!hospital.doctors.find(function(doctor) {
                                                                return doctor.contractType === types_hospital/* ContractType.All */.RJ.All;
                                                            }),
                                                            isLastItem: index === viewModel.hospitals.length - 1 || index === 1 && !!viewModel.matchedCategory
                                                        })
                                                    })
                                                }, "event-".concat(hospital.hospitalPublicId)),
                                                index === 1 && viewModel.matchedCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDoctorListBannerWrapper, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonF2fDoctorListBanner, {
                                                        onClick: function() {
                                                            return viewModel.openAppInstallBottomSheet({
                                                                campaign: "web_hospitals_neighborhood",
                                                                content: "web_content_bnr_list",
                                                                term: "".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion), " ").concat(viewModel.queries.keyword, "}{' '}비대면 진료 받기"),
                                                                sub_id: viewModel.queries.keyword,
                                                                sub_id_1: viewModel.queries.regionCode,
                                                                sub_id_2: viewModel.queries.type,
                                                                sub_id_3: viewModel.queries.filter
                                                            });
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonF2fDoctorListBannerContent, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDiagnosisBannerIcon/* default */.Z, {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonF2fDcotorListBannerTextArea, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonF2fDoctorListBannerTitle, {
                                                                                children: [
                                                                                    "".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion), " ").concat(viewModel.queries.keyword),
                                                                                    " ",
                                                                                    "비대면 진료 받기"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDoctorListBannerDescription, {
                                                                                children: "병원 가지 않아도 진료를 볼 수 있어요"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                                                                direction: common/* DIRECTION.RIGHT */.JR.RIGHT,
                                                                width: 12,
                                                                height: 12,
                                                                color: theme/* default.color.gray300 */.Z.color.gray300
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        });
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full px-[24px] py-[20px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: common/* ROUTES.HOSPITAL.SEARCH.path */.Z6.HOSPITAL.SEARCH.path + (0,url/* addQueryString */.sC)({
                                        keyword: viewModel.queries.keyword,
                                        mode: types_hospital/* HospitalSearchMode.SEARCH */.LC.SEARCH,
                                        sortType: types_hospital/* HospitalSearchSortType.ACCURACY */.k_.ACCURACY
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "typography-ui-15sb flex h-[40px] w-full items-center justify-center gap-[4px] rounded-[8px] border-[1px] border-gray-100 border-solid text-gray-600",
                                            children: [
                                                "병원 더보기",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                    name: "keyboard_arrow_right",
                                                    size: 20,
                                                    color: theme/* default.color.gray600 */.Z.color.gray600,
                                                    filled: true
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NeighborhoodSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NeighborhoodTopWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NeighborhoodTitle, {
                                        children: client.isMobile ? "".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion), " ").concat(viewModel.queries.keyword, "\n").concat(viewModel.neighborhoodHospitalTypes.selectedTypeTitle(viewModel.queries.type), " 병원에서\n 비대면 진료를 받을 수 있어요") : "".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion), " ").concat(viewModel.queries.keyword, " ").concat(viewModel.neighborhoodHospitalTypes.selectedTypeTitle(viewModel.queries.type), " 병원에서\n 비대면 진료를 받을 수 있어요")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NeighborhoodDescription, {
                                        children: "병원에 가기 힘들다면, ".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion), " ").concat(viewModel.queries.keyword, " 선생님에게 전화로 진료를 받아보세요.")
                                    })
                                ]
                            }),
                            !viewModel.isLoadingHospitals && viewModel.nonF2fDoctors.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmptyNeighborhoodSearchResult, {
                                title: "가까운 의사가 없어요",
                                description: "닥터나우 앱으로 \n병원에 방문하지 않아도 진료 받을 수 있어요",
                                noticeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyImage, {
                                    width: 200,
                                    src: "/images/neighborhood/empty_hospital.png",
                                    alt: "의사 안내 이미지"
                                }),
                                button: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyButton, {
                                    onClick: function() {
                                        return viewModel.openAppInstallBottomSheet({
                                            campaign: "web_hospitals_neighborhood",
                                            content: "web_content_bnr_list",
                                            term: "비대면으로 편하게 진료 보기",
                                            sub_id: viewModel.queries.keyword,
                                            sub_id_1: viewModel.queries.regionCode,
                                            sub_id_2: viewModel.queries.type,
                                            sub_id_3: viewModel.queries.filter
                                        });
                                    },
                                    children: "비대면으로 편하게 진료 보기"
                                })
                            }),
                            !viewModel.isLoadingHospitals && viewModel.nonF2fDoctors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorListWrapper, {
                                        children: viewModel.nonF2fDoctors.map(function(doctor, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "".concat(common/* ROUTES.DOCTOR.DETAIL.path */.Z6.DOCTOR.DETAIL.path, "/").concat(doctor.publicId),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_self",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NeighborhoodSearchDoctorItem, {
                                                        doctorName: doctor.doctorName,
                                                        hospitalName: doctor.hospitalName,
                                                        doctorProfileImageUrl: doctor.profileImageUrl,
                                                        reviewRating: doctor.reviewAverageRating,
                                                        reviewTotalCount: doctor.reviewTotalCount,
                                                        videoCallAvailable: doctor.readyForVideoCall,
                                                        professionalDepartmentName: doctor.professionalDepartmentName,
                                                        isLastItem: index === viewModel.nonF2fDoctors.length - 1
                                                    }, "neighborhood-doctor-".concat(doctor.publicId))
                                                })
                                            }, "neighborhood-doctor-".concat(doctor.publicId));
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorButtonWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimarySearchButton, {
                                            onClick: function() {
                                                return viewModel.openAppInstallBottomSheet({
                                                    campaign: "web_hospitals_neighborhood",
                                                    content: "web_content_btn_list",
                                                    term: "".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion), " ").concat(viewModel.queries.keyword, "} 진료 편하게 보기"),
                                                    sub_id: viewModel.queries.keyword,
                                                    sub_id_1: viewModel.queries.regionCode,
                                                    sub_id_2: viewModel.queries.type,
                                                    sub_id_3: viewModel.queries.filter
                                                });
                                            },
                                            children: "".concat(viewModel.koreaAddress.getAddressTitle(viewModel.queryRegion), " ").concat(viewModel.queries.keyword, " 진료 편하게 보기")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            viewModel.isAddressFilterModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(non_benefit/* SearchAddressFilterModal */.Sc, (0,_object_spread/* default */.Z)({}, viewModel.getSearchAddressFilterModalProps()))
        ]
    });
};
/* harmony default export */ var neighborhood_NeighborhoodHospitalTemplate = (NeighborhoodHospitalTemplate);
var BreadCrumbsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-0"
})(NeighborhoodHospitalTemplate_templateObject(), function(param) {
    var theme = param.theme;
    return theme.client.isMobile ? "0" : "24px 24px 16px";
});
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-c12614f0-1"
})(NeighborhoodHospitalTemplate_templateObject1());
var HospitalTitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-2"
})(NeighborhoodHospitalTemplate_templateObject2());
var HeaderTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-c12614f0-3"
})(NeighborhoodHospitalTemplate_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NeighborhoodHospitalTemplate_templateObject3(), theme.typography.UI22SB, theme.color.gray900);
});
var HeaderDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-c12614f0-4"
})(NeighborhoodHospitalTemplate_templateObject6(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NeighborhoodHospitalTemplate_templateObject5(), theme.typography.UI15R, theme.color.gray500);
});
var HospitalFilterOptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-5"
})(NeighborhoodHospitalTemplate_templateObject7());
var FilterButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c12614f0-6"
})(NeighborhoodHospitalTemplate_templateObject9(), function(param) {
    var theme = param.theme, selected = param.selected;
    return (0,styled_components_browser_esm/* css */.iv)(NeighborhoodHospitalTemplate_templateObject8(), theme.typography.UI14R, selected ? theme.color.primary700 : theme.color.gray700, selected ? theme.color.primary100 : theme.color.gray30, selected ? theme.color.primary700 : theme.color.gray30, selected ? theme.color.primary700 : theme.color.gray700);
});
var HospitalListWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c12614f0-7"
})(NeighborhoodHospitalTemplate_templateObject10());
var DoctorListWrapper = (0,styled_components_browser_esm/* default */.ZP)(HospitalListWrapper).withConfig({
    componentId: "sc-c12614f0-8"
})(NeighborhoodHospitalTemplate_templateObject11());
var NonF2fDoctorListBannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-9"
})(NeighborhoodHospitalTemplate_templateObject12());
var NonF2fDoctorListBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-10"
})(NeighborhoodHospitalTemplate_templateObject13(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});
var NonF2fDoctorListBannerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-11"
})(NeighborhoodHospitalTemplate_templateObject14());
var NonF2fDcotorListBannerTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-12"
})(NeighborhoodHospitalTemplate_templateObject15());
var NonF2fDoctorListBannerTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-13"
})(NeighborhoodHospitalTemplate_templateObject16(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI14M, ";\n      color: ").concat(theme.color.gray800, ";\n    ");
});
var NonF2fDoctorListBannerDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-14"
})(NeighborhoodHospitalTemplate_templateObject17(), function(param) {
    var theme = param.theme;
    return "\n      ".concat(theme.typography.UI12R, ";\n      color: ").concat(theme.color.gray500, "\n    ");
});
var NeighborhoodSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c12614f0-15"
})(NeighborhoodHospitalTemplate_templateObject19(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NeighborhoodHospitalTemplate_templateObject18(), theme.color.gray50);
});
var NeighborhoodTopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-16"
})(NeighborhoodHospitalTemplate_templateObject20());
var NeighborhoodTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-c12614f0-17"
})(NeighborhoodHospitalTemplate_templateObject22(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NeighborhoodHospitalTemplate_templateObject21(), theme.typography.UI22SB, theme.color.gray900);
});
var NeighborhoodDescription = (0,styled_components_browser_esm/* default */.ZP)(HeaderDescription).withConfig({
    componentId: "sc-c12614f0-18"
})(NeighborhoodHospitalTemplate_templateObject23());
var SearchButton = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    type: "button"
}).withConfig({
    componentId: "sc-c12614f0-19"
})(NeighborhoodHospitalTemplate_templateObject25(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NeighborhoodHospitalTemplate_templateObject24(), theme.typography.UI16SB, theme.color.gray600, theme.color.white, theme.color.gray100);
});
var PrimarySearchButton = (0,styled_components_browser_esm/* default */.ZP)(SearchButton).withConfig({
    componentId: "sc-c12614f0-20"
})(NeighborhoodHospitalTemplate_templateObject27(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NeighborhoodHospitalTemplate_templateObject26(), theme.color.primary700, theme.color.primary100, theme.color.primary100);
});
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c12614f0-21"
})(NeighborhoodHospitalTemplate_templateObject28());
var DoctorButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(ButtonWrapper).withConfig({
    componentId: "sc-c12614f0-22"
})(NeighborhoodHospitalTemplate_templateObject29());
var EmptyImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-c12614f0-23"
})(NeighborhoodHospitalTemplate_templateObject30());
var EmptyButton = (0,styled_components_browser_esm/* default */.ZP)(SearchButton).withConfig({
    componentId: "sc-c12614f0-24"
})(NeighborhoodHospitalTemplate_templateObject32(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NeighborhoodHospitalTemplate_templateObject31(), theme.color.white, theme.color.primary600, theme.color.primary600);
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/components/molecules/bottom-sheet/index.tsx + 5 modules
var bottom_sheet = __webpack_require__(5679);
;// CONCATENATED MODULE: ./src/components/common/bottom-sheet/select-bottom-sheet/index.tsx

function select_bottom_sheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0 32px;\n"
    ]);
    select_bottom_sheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function select_bottom_sheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    padding: 0 24px;\n    margin-bottom: 20px;\n  "
    ]);
    select_bottom_sheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function select_bottom_sheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    select_bottom_sheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function select_bottom_sheet_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 500px;\n  overflow-y: scroll;\n"
    ]);
    select_bottom_sheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function select_bottom_sheet_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > p {\n      ",
        "\n      color: ",
        ";\n    }\n  "
    ]);
    select_bottom_sheet_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function select_bottom_sheet_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: 56px;\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    select_bottom_sheet_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var SelectBottomSheet = function(props) {
    var title = props.title, list = props.list, onClick = props.onClick, getItemName = props.getItemName, onClose = props.onClose, isSelected = props.isSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_sheet/* default */.ZP, {
        isOpened: true,
        onClickOverlay: onClose,
        index: 500,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_bottom_sheet_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterModalTitle, {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList, {
                    children: list.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter, {
                            onClick: function() {
                                return onClick(item);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: getItemName(item)
                                }),
                                isSelected && isSelected(item) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                    name: "check",
                                    size: 32,
                                    color: theme/* default.color.primary500 */.Z.color.primary500
                                })
                            ]
                        }, "filter-".concat(getItemName(item)));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var select_bottom_sheet = (SelectBottomSheet);
var select_bottom_sheet_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f20cff85-0"
})(select_bottom_sheet_templateObject());
var FilterModalTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-f20cff85-1"
})(select_bottom_sheet_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(select_bottom_sheet_templateObject1(), theme.typography.UI22SB, theme.color.gray900);
});
var FilterList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-f20cff85-2"
})(select_bottom_sheet_templateObject3());
var Filter = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-f20cff85-3"
})(select_bottom_sheet_templateObject5(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(select_bottom_sheet_templateObject4(), theme.typography.UI16M, theme.color.gray800);
});

// EXTERNAL MODULE: ./src/components/templates/f2f/hospital/hospital-bottom-sheet/non-f2f-diagnosis-app-install-bottom-sheet/NonF2fDiagnosisAppInstallBottomSheet.tsx + 1 modules
var NonF2fDiagnosisAppInstallBottomSheet = __webpack_require__(34701);
// EXTERNAL MODULE: ./src/components/templates/f2f/hospital/hospital-bottom-sheet/non-f2f-diagnosis-app-install-qr-code-bottom-sheet/NonF2fDiagnosisAppInstallQrCodeBottomSheet.tsx
var NonF2fDiagnosisAppInstallQrCodeBottomSheet = __webpack_require__(38494);
// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(99529);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/entities/region/model/Region.ts
var Region = __webpack_require__(89109);
// EXTERNAL MODULE: ./src/entities/region/model/KoreaAddress.ts
var KoreaAddress = __webpack_require__(56652);
// EXTERNAL MODULE: ./src/hooks/hospital/list/useSearchHospitalsGenerally.ts + 2 modules
var useSearchHospitalsGenerally = __webpack_require__(92312);
// EXTERNAL MODULE: ./src/hooks/hospital/main/useMedicalCategories.ts
var useMedicalCategories = __webpack_require__(21586);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useSearchKoreaAddressV2.ts
var useSearchKoreaAddressV2 = __webpack_require__(75527);
// EXTERNAL MODULE: ./src/hooks/search/magazine/useGetKeywordSearchMagazineInfinite.ts + 1 modules
var useGetKeywordSearchMagazineInfinite = __webpack_require__(58104);
// EXTERNAL MODULE: ./src/hooks/search/useInfiniteSearchNonF2fDoctors.ts
var useInfiniteSearchNonF2fDoctors = __webpack_require__(48115);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
;// CONCATENATED MODULE: ./src/hooks/hospital/neighborhood/useNeighborhoodHospitalViewModel.tsx


























var useNeighborhoodHospitalViewModel = function(client) {
    var ref = (0,useCustomRouter/* default */.Z)(), router = ref.router, moveToPage = ref.moveToPage;
    var ref1 = (0,useModal/* default */.Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var queries = router.query;
    var _regionCode = queries.regionCode, regionCode = _regionCode === void 0 ? "" : _regionCode, _keyword = queries.keyword, keyword = _keyword === void 0 ? "" : _keyword, _type = queries.type, type = _type === void 0 ? hospital/* NeighborhoodHospitalType.ALL */.d7.ALL : _type, _filter = queries.filter, filter = _filter === void 0 ? hospital/* NeighborhoodHospitalFilter.F2fHospital */.nx.F2fHospital : _filter;
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    var ref2 = (0,react.useState)(false), isAddressFilterModalOpen = ref2[0], setIsAddressFilterModalOpen = ref2[1];
    var neighborhoodHospitalTypes = (0,react.useMemo)(function() {
        return new hospital/* NeighborhoodHospitalTypes */.s4();
    }, []);
    var ref3 = (0,useMedicalCategories/* default */.Z)({
        sortType: gql_schema/* MedicalCategorySortType.Alphabet */.eAd.Alphabet
    }), tmp = ref3.data, departments = tmp === void 0 ? [] : tmp;
    /* 지역 검색 */ var queryRegion = new Region/* Region */.y(regionCode);
    var ref4 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: null,
        siGunGuCode: null
    }), tmp1 = ref4.data, siDoList = tmp1 === void 0 ? [] : tmp1;
    var ref5 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: queryRegion.excludeSejongSiDoRegionCode(),
        siGunGuCode: null
    }), tmp2 = ref5.data, siGunGuList = tmp2 === void 0 ? [] : tmp2;
    var ref6 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: queryRegion.regionCodes.siDoCode,
        siGunGuCode: queryRegion.excludeSejongSiGunGuRegionCode()
    }), tmp3 = ref6.data, dongList = tmp3 === void 0 ? [] : tmp3;
    /* 관련 컨텐츠 및 QNA */ var ref7 = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: keyword,
        size: 10,
        contentType: magazine/* MagazineType.FAQ */.rL.FAQ
    }), faqs = ref7.magazines;
    var magazines = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: keyword,
        size: 10,
        contentType: magazine/* MagazineType.ARTICLE */.rL.ARTICLE
    }).magazines;
    var ref8 = (0,useSearchHospitalsGenerally/* default */.Z)(useSearchHospitalsGenerally/* default.parseParameterByNeighborhoodHospital */.Z.parseParameterByNeighborhoodHospital({
        keyword: keyword,
        regionCode: regionCode,
        filter: filter,
        hospitalType: type
    })), _hospitals = ref8.hospitals, hospitals = _hospitals === void 0 ? [] : _hospitals, isLoadingHospitals = ref8.isLoadingHospitals;
    var nonF2fDoctors = hospitals.flatMap(function(hospital) {
        return hospital.doctors.filter(function(doctor) {
            return doctor.contractType !== types_hospital/* ContractType.FaceToFace */.RJ.FaceToFace;
        });
    }).slice(0, 5);
    var ref9 = (0,useInfiniteSearchNonF2fDoctors/* default */.Z)({
        request: {
            keyword: keyword,
            sortType: gql_schema/* DoctorSortType.Random */.tt_.Random,
            page: 1,
            limit: 1,
            doctorType: gql_schema/* DoctorType.Doctor */.J42.Doctor,
            telemedicineEligibleTargetType: gql_schema/* TelemedicineEligibleTargetType.AlwaysEligible */.H7r.AlwaysEligible
        }
    }, {
        enabled: !!keyword
    }), matchedCategory = ref9.category;
    /* 선택된 지역 */ var koreaAddress = new KoreaAddress/* KoreaAddress */.c(siDoList, siGunGuList, dongList);
    var openDynamicLink = function(options) {
        airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, options);
    };
    var openAppInstallBottomSheet = function(options) {
        if (client.isMobile) {
            return showModal({
                type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
                props: {
                    body: /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDiagnosisAppInstallBottomSheet/* default */.Z, {
                        onClickAppInstall: function() {
                            openDynamicLink(options);
                        },
                        onClickOverlay: closeModal
                    })
                }
            });
        }
        return showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(NonF2fDiagnosisAppInstallQrCodeBottomSheet/* default */.Z, {
                    appInstallLink: airbridgeDynamicLink.getDynamicLink(options),
                    onClickOverlay: closeModal
                })
            }
        });
    };
    var onCloseSearchAddressFilterModal = function() {
        setIsAddressFilterModalOpen(false);
    };
    var onUpdateAddress = function(item) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                regionCode: item.regionCode
            })
        });
    };
    var onSelectAddress = function(item) {
        onUpdateAddress(item);
        onCloseSearchAddressFilterModal();
    };
    var openSearchAddressFilterModal = function() {
        setIsAddressFilterModalOpen(true);
    };
    var toggleNonF2fHospitalFilter = function() {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                filter: filter === hospital/* NeighborhoodHospitalFilter.F2fHospital */.nx.F2fHospital ? hospital/* NeighborhoodHospitalFilter.NonF2fHospital */.nx.NonF2fHospital : hospital/* NeighborhoodHospitalFilter.F2fHospital */.nx.F2fHospital
            })
        });
    };
    var selectNeighborhoodHospitalType = function(type) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                type: type
            })
        });
        closeModal();
    };
    var selectNeighborhoodKeyword = function(department) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                keyword: department.name
            })
        });
        closeModal();
    };
    var openNeighborhoodHospitalTypeBottomSheet = function() {
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_bottom_sheet, {
                    title: "병원 종류를 선택해주세요",
                    list: neighborhoodHospitalTypes.list,
                    onClick: selectNeighborhoodHospitalType,
                    isSelected: function(item) {
                        return item === type;
                    },
                    getItemName: function(item) {
                        return "".concat(neighborhoodHospitalTypes.selectedTypeTitle(item), " 병원");
                    },
                    onClose: closeModal
                })
            }
        });
    };
    var openNeighborhoodKeywordBottomSheet = function() {
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_bottom_sheet, {
                    title: "진료 과목을 선택해주세요",
                    list: departments,
                    onClick: selectNeighborhoodKeyword,
                    isSelected: function(item) {
                        return item.name === keyword;
                    },
                    getItemName: function(item) {
                        return item.name;
                    },
                    onClose: closeModal
                })
            }
        });
    };
    var onClickRelatedMagazine = function(magazinePid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazinePid),
            mobileScreenName: common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName,
            params: {
                id: magazinePid
            }
        });
    };
    var onClickRelatedFaq = function(magazinePid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(magazinePid),
            mobileScreenName: common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: magazinePid
            }
        });
    };
    var getSearchAddressFilterModalProps = function() {
        return {
            switchRegionFilter: onCloseSearchAddressFilterModal,
            siDoList: siDoList,
            siGunGuList: siGunGuList,
            dongList: dongList,
            selectedRegion: koreaAddress.getSelectedRegionByDepth(queryRegion),
            onSelectAddress: onSelectAddress,
            onUpdateAddress: onUpdateAddress,
            isOpened: true,
            isSejong: queryRegion.isSejongRegion,
            client: client
        };
    };
    var getNeighborhoodSeoProps = function() {
        return {
            title: "".concat(koreaAddress.getAddressTitle(queryRegion), " ").concat(neighborhoodHospitalTypes.selectedTypeTitle(type), " 병원 비교 | ").concat(keyword, " (2025)"),
            description: "".concat(neighborhoodHospitalTypes.selectedTypeTitle(type), " 병원 정보와 후기를 바탕으로 ").concat(koreaAddress.getAddressTitle(queryRegion), " ").concat(keyword, " 병원 중 잘하는 곳을 위주로 추천해드릴게요."),
            canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.HOSPITAL.NEIGHBORHOOD.path */.Z6.HOSPITAL.NEIGHBORHOOD.path).concat((0,url/* addQueryString */.sC)({
                keyword: keyword,
                regionCode: regionCode,
                type: type
            }))
        };
    };
    (0,react.useEffect)(function() {
        if (keyword) {
            pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, (0,_object_spread/* default */.Z)({
                subject: keyword
            }, koreaAddress.getAddressTitle(queryRegion) && {
                region: koreaAddress.getAddressTitle(queryRegion)
            }));
        }
    }, [
        keyword
    ]);
    return {
        isLoadingHospitals: isLoadingHospitals,
        hospitals: hospitals,
        nonF2fDoctors: nonF2fDoctors,
        queries: queries,
        queryRegion: queryRegion,
        koreaAddress: koreaAddress,
        faqs: faqs,
        magazines: magazines,
        matchedCategory: matchedCategory,
        getSearchAddressFilterModalProps: getSearchAddressFilterModalProps,
        isAddressFilterModalOpen: isAddressFilterModalOpen,
        neighborhoodHospitalTypes: neighborhoodHospitalTypes,
        openNeighborhoodHospitalTypeBottomSheet: openNeighborhoodHospitalTypeBottomSheet,
        openSearchAddressFilterModal: openSearchAddressFilterModal,
        toggleNonF2fHospitalFilter: toggleNonF2fHospitalFilter,
        openAppInstallBottomSheet: openAppInstallBottomSheet,
        onClickRelatedFaq: onClickRelatedFaq,
        onClickRelatedMagazine: onClickRelatedMagazine,
        getNeighborhoodSeoProps: getNeighborhoodSeoProps,
        departments: departments,
        openNeighborhoodKeywordBottomSheet: openNeighborhoodKeywordBottomSheet
    };
};
/* harmony default export */ var neighborhood_useNeighborhoodHospitalViewModel = (useNeighborhoodHospitalViewModel);

;// CONCATENATED MODULE: ./src/pages/hospitals/neighborhood/index.tsx
// PageDescription: 우리동네 병원 검색 페이지






var NeighborhoodHospitalPage = function(param) {
    var client = param.client;
    var viewModel = neighborhood_useNeighborhoodHospitalViewModel(client);
    var ref = viewModel.getNeighborhoodSeoProps(), title = ref.title, description = ref.description, canonical = ref.canonical;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                canonical: canonical,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/og-main.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(neighborhood_NeighborhoodHospitalTemplate, {
                viewModel: viewModel,
                client: client
            })
        ]
    });
};
NeighborhoodHospitalPage.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var neighborhood = (NeighborhoodHospitalPage);


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,6492,9097,1498,2110,7654,4059,3547,8391,9653,5180,1743,4365,5679,2149,1950,5250,5,5247,5203,8185,8813,2856,3650,7808,5894,9774,2888,179], function() { return __webpack_exec__(64633); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);